<template>
    <div id="modalLogout" class="modal show" tabIndex="-1" role="dialog" data-backdrop="false">
        <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content text-center">
                <div class="modal-body text-center">
                    <div class="alert text-white bg-primary fade show font-weight-bold" role="alert">
                        You're now logged out.
                    </div>
                    <button class="btn btn-link" data-dismiss="modal">
                        <span aria-hidden="true" class="display-2">×</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import jquery from "jquery";

export default {
  methods: {
    show() {
      jquery("#modalLogout").modal("show");
    }
  }
}
</script>
